import React, { forwardRef } from 'react';
import ProductionScheduleScheduleRenderer from './ProductionScheduleScheduleRenderer';
import ProductionScheduleGanttRenderer from './ProductionScheduleGanttRenderer';
import type {
  ZoomLevel,
  ScheduleOperation,
  ScheduleSetup,
  ScheduleResource,
  ScheduleResourceShift,
  ProductionScheduleRendererProps,
  ProductionScheduleViewHandle,
  ProductionScheduleRendererType
} from './ProductionScheduleViewTypes';

export type {
  ZoomLevel,
  ScheduleOperation,
  ScheduleSetup,
  ScheduleResource,
  ScheduleResourceShift,
  ProductionScheduleRendererProps,
  ProductionScheduleViewHandle
};

export interface ProductionScheduleViewProps extends ProductionScheduleRendererProps {
  /** Renderer: 'schedule' = Syncfusion ScheduleComponent, 'gantt' = Syncfusion GanttComponent. Default: 'gantt'. */
  renderer?: ProductionScheduleRendererType;
}

/** Registry of available renderers. Extend this to add new implementations. */
const RENDERER_REGISTRY: Record<
  ProductionScheduleRendererType,
  React.ForwardRefExoticComponent<
    ProductionScheduleRendererProps & React.RefAttributes<ProductionScheduleViewHandle>
  >
> = {
  schedule: ProductionScheduleScheduleRenderer,
  gantt: ProductionScheduleGanttRenderer
};

const ProductionScheduleView = forwardRef<ProductionScheduleViewHandle, ProductionScheduleViewProps>(
  ({ renderer = 'gantt', ...props }, ref) => {
    const RendererComponent = RENDERER_REGISTRY[renderer] ?? RENDERER_REGISTRY.gantt;
    return <RendererComponent ref={ref} {...props} />;
  }
);

ProductionScheduleView.displayName = 'ProductionScheduleView';

export default ProductionScheduleView;
